var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#393969",
    d: "M16.157 6.857H7.183c-.275 0-.335.18-.33.27v2.374c-.005.275.201.36.3.356h3.133v7.997c0 .613.582.995.938.995c.583.004 1.822.017 2.087 0c.27-.022.403-.296.403-.429V9.857h3.137c.215 0 .283-.214.288-.313c0-.154.008-.87 0-1.654c-.013-.78-.57-1.033-.986-1.033z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAva);
export default __webpack_public_path__ + "static/media/ava.e0d3754a5b36ba1767134ea7107a48be.svg";
export { ForwardRef as ReactComponent };